module.exports = __webpack_public_path__ + "static/img/kehuanli-3.ca765cbc.jpg";